/* eslint-disable react/no-danger */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../../core/i18n";

export function ShareStatus(props: { shareState : any }) {
  if (props.shareState?.sharingStatus === "private") {
    return <p><FontAwesomeIcon icon="lock" />&nbsp; <span dangerouslySetInnerHTML={{ __html: translate("share-status-private-text") }} /></p>;
  } else if (props.shareState?.sharingStatus === "public") {
    return <p><FontAwesomeIcon icon="lock-open" />&nbsp; <span dangerouslySetInnerHTML={{ __html: translate("share-status-public-text") }} /></p>;
  }
  return <p className="alert alert-warning"><FontAwesomeIcon icon="ban" />&nbsp; {translate("share-status-unavailable")}</p>;
}
